namespace GeniuzPOS.SalePromoCamp {
    export class PromoDayColumns {
        static columnsKey = 'SalePromoCamp.PromoDay';
    }
}
